import { SimXAgreement } from '../../../shared/models/entities/simx-agreement.model';
import { SimXUser } from '../../../shared/models/entities/simx-user.model';

export interface State {
  isAcceptingAgreement: boolean;
  isAuthenticated: boolean;
  isAuthenticating: boolean;
  isDeletingUserSignedAgreement: { userAgreementId: string } | null;
  isLoggedIn: boolean;
  isLoggingIn: boolean;
  isLoggingOut: boolean;
  token: string;
  unsignedAgreements: Array<SimXAgreement>;
  user: SimXUser | null;
}

export const initialState: State = {
  isAcceptingAgreement: false,
  isAuthenticated: false,
  isAuthenticating: false,
  isDeletingUserSignedAgreement: null,
  isLoggedIn: false,
  isLoggingIn: false,
  isLoggingOut: false,
  token: null,
  unsignedAgreements: [],
  user: null,
};
